
import { defineComponent, ref, computed, toRefs, watch } from "vue"
import { useStore } from "vuex"
import { Actions } from "@/store/enums/StoreEnums"
import { ElMessage } from "element-plus"
import { MatchPool, SimulationResult } from "@/store/modules/MatchPoolModule"

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    matchPool: {
      type: Object as () => MatchPool | null,
      default: null
    }
  },
  emits: ['update:visible', 'simulated'],
  setup(props, { emit }) {
    const store = useStore()
    const { matchPool, visible } = toRefs(props)

    const simulationCount = ref(10000)
    const loading = ref(false)
    const result = ref<SimulationResult | null>(null)

    const priceYuan = computed(() => {
      if (!matchPool.value) return 0
      return Number(matchPool.value.price).toFixed(2)
    })

    const averageCostYuan = computed(() => {
      if (!result.value) return 0
      return Number(result.value.average_cost).toFixed(2)
    })

    const averageRewardYuan = computed(() => {
      if (!result.value) return 0
      return Number(result.value.average_reward_value).toFixed(2)
    })

    const expectedProfitYuan = computed(() => {
      if (!result.value) return 0
      return Number(result.value.expected_profit).toFixed(2)
    })

    const getMatchCountTagType = (matchCount: number) => {
      if (matchCount === 0) return 'info'
      if (matchCount >= 9) return 'danger'
      if (matchCount >= 5) return 'warning'
      return 'success'
    }

    const getProgressColor = (percentage: number) => {
      if (percentage >= 30) return '#F56C6C'
      if (percentage >= 15) return '#E6A23C'
      return '#67C23A'
    }

    const runSimulation = async () => {
      if (!matchPool.value?.id) {
        ElMessage.error('请先选择池子')
        return
      }

      loading.value = true
      try {
        const data = await store.dispatch(Actions.SIMULATE_MATCH_POOL, {
          id: matchPool.value.id,
          times: simulationCount.value
        })
        result.value = data
        emit('simulated', data)
      } catch (error: unknown) {
        const errorMsg = (error as { error_msg?: string })?.error_msg || '模拟失败'
        ElMessage.error(errorMsg)
      } finally {
        loading.value = false
      }
    }

    // 当弹窗打开时重置结果
    watch(visible, (newVal) => {
      if (newVal) {
        result.value = null
      }
    })

    return {
      simulationCount,
      loading,
      result,
      priceYuan,
      averageCostYuan,
      averageRewardYuan,
      expectedProfitYuan,
      getMatchCountTagType,
      getProgressColor,
      runSimulation
    }
  }
})
